import { mapDispatchToProps, mapStateToProps } from "../../../helpers";
import { connect } from "react-redux";
import "./DocsManager.css";
import { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { getHeaders } from "../../../redux/actions/postActions";
import axios from "axios";
import { API_URL } from "../../../redux/constants";
import PdfViewer from "./PdfViewer";
import Loader from "../../../components/Loader";
import { useTranslation } from "react-i18next";

function DocsManager(props) {
  const { docs360Data } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  const documents = useMemo(() => Array.isArray(docs360Data) ? docs360Data : [], [docs360Data]);

  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [openPdfViewer, setOpenPdfViewer] = useState(false);
  const [attachmentResponse, setAttachmentResponse] = useState(null);

  const handleOpenAttachments = (doc) => {
    setSelectedDoc(doc);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedDoc(null);
  };

  const handleViewAttachment = (e, attachment) => {
    e.preventDefault();
    let loanGuid = localStorage.getItem("loanGuid");
    setOpen(false);
    setLoader(true);
    axios
    .get(`${API_URL}/customer-service/api/v1/cx/loans/${loanGuid}/attachments/${attachment?.entityId}`, {
      headers: getHeaders(),
    })
    .then((response) => {
      setAttachmentResponse(response?.data);
      setLoader(false);
      triggerPdfViewerDialogBox();
    })
    .catch((error) => {
      setLoader(false);
      console.error("Error in fetching data:", error);
    });
  };

  const openAttachmentApiRes = (e, doc) => { 
    e.preventDefault(); 
    handleOpenAttachments(doc);
  };
  const triggerPdfViewerDialogBox = () => {
    setOpenPdfViewer(!openPdfViewer);
    // setLoader(false);
  };
  if(!Array.isArray(documents) || documents?.length === 0) {
    return <div className="noDataFoundText">No documents available</div>;
  } else {
    return (
      <div className="docs-container">
        {loader && <Loader open={loader} />}
        <TableContainer component={Paper} className="docs-table-container">
          <Table size="small" aria-label="documents table" className="docs-table">
            <TableHead>
              <TableRow>
                <TableCell className="docs-th"><strong>{t("Title")}</strong></TableCell>
                <TableCell align="left" className="docs-th"><strong>{t("Attachments")}</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documents.map((doc) => (
                <TableRow key={doc.id} hover>
                  <TableCell component="th" scope="row">
                    {doc.title}
                  </TableCell>
                  <TableCell align="left">
                    <Link className="docs-attachments-link" href="#" onClick={(e) => openAttachmentApiRes(e, doc)}>
                      {t("Open attachments")}
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          // fullScreen={fullScreen}
          fullWidth
          maxWidth="sm"
          open={open}
          onClose={handleClose}
          aria-labelledby="attachments-dialog-title"
          className="docs-attachments-dialog"
        >
          <DialogTitle id="attachments-dialog-title" className="docs-dialog-title">
            {selectedDoc ? `${selectedDoc.title}` : t("Attachments")}
            <IconButton aria-label="close" onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="docs-dialog-content">
            <TableContainer component={Paper} className="attachments-table-container">
              <Table size="small" aria-label="attachments table" className="attachments-table">
                <TableHead>
                  <TableRow>
                    <TableCell className="docs-th"><strong>{t("Attachment Name")}</strong></TableCell>
                    <TableCell align="left" className="docs-th attachment-action-header"><strong>{t("View attachment")}</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(selectedDoc?.attachments || []).map((att) => (
                    <TableRow key={att.entityId} hover>
                      <TableCell component="th" scope="row" className="attachment-name-cell">{att.entityName}</TableCell>
                      <TableCell align="left" className="attachment-action-cell">
                        <Link className="view-attachment-link" href="#" onClick={(e) => handleViewAttachment(e, att)}>
                          {t("View attachment")}
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </Dialog>
        {openPdfViewer && (
          <PdfViewer
            url={attachmentResponse}
            open={openPdfViewer}
            handleClosePdfViewer={() => triggerPdfViewerDialogBox()}
            loading={loader}
          />
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DocsManager);
